import { connect } from "react-redux";
import get from "lodash/get";
import { SignatoryPreferredMailingAddressComponent } from "./SignatoryPreferredMailingAddress";
import { getOrganizationInfo } from "../../../../store/selectors/appConfig";
import { updateProspect } from "../../../../store/actions/appConfig";
import { getIsEditableStatusSearchInfo } from "../../../../store/selectors/searchProspect";
const mapDispatchToProps = {
  updateProspect
};
const mapStateToProps = state => ({
  organisationAddressLine2: get(getOrganizationInfo(state), "addressDetails.addressLine2", ""),
  organisationAddressLine1: get(getOrganizationInfo(state), "addressDetails.addressLine1", ""),
  organisationAddressLine3: get(getOrganizationInfo(state), "addressDetails.addressLine3", ""),
  organisationAddressLine4: get(getOrganizationInfo(state), "addressDetails.addressLine4", ""),
  organisationEmirateCity: get(getOrganizationInfo(state), "addressDetails.emirateCity", ""),
  organisationPoBox: get(getOrganizationInfo(state), "addressDetails.poBox", ""),
  organisationCountry: get(getOrganizationInfo(state), "addressDetails.country", ""),
  isComeFromROScreens: getIsEditableStatusSearchInfo(state)
});
export const SignatoryPreferredMailingAddress = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignatoryPreferredMailingAddressComponent);
